import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";

export default function PackageDownload() {
    const { token } = useParams();
    const [pkg, setPkg] = useState(null);
    const [err, setErr] = useState(null);
    const expires_str = pkg?.expires_at ? new Date(pkg.expires_at).toLocaleDateString() : "";

    useEffect(() => {
        api.get(`/packages/download/${token}`).then((r) => setPkg(r.data)).catch((e) => setErr(e?.response?.data?.detail || "Link invalid or expired"));
    }, [token]);

    if (err) {
        return (
            <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--gt-bg)" }}>
                <div className="gt-card p-8 text-center max-w-md">
                    <div style={{ fontSize: 36, color: "var(--gt-red)" }}><i className="fa-solid fa-triangle-exclamation"></i></div>
                    <h1 className="font-display text-2xl mt-3 mb-2">Link unavailable</h1>
                    <p className="text-sm" style={{ color: "var(--gt-text-2)" }}>{err}</p>
                </div>
            </div>
        );
    }

    if (!pkg) return <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--gt-bg)", color: "var(--gt-text-2)" }}>Loading package…</div>;

    return (
        <div className="min-h-screen" style={{ background: "var(--gt-bg)" }}>
            <section className="pt-20 pb-16">
                <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="overline mb-3">Secure Package Delivery</div>
                    <h1 className="font-display text-4xl lg:text-5xl mb-3" data-testid="pkg-title">{pkg.name}</h1>
                    {pkg.subtitle && <p className="mb-6 max-w-2xl" style={{ color: "var(--gt-text-2)" }}>{pkg.subtitle}</p>}
                    {expires_str && <div className="overline" style={{ fontSize: 10 }}>Link expires {expires_str}</div>}
                    <a
                        data-testid="pkg-dossier-btn"
                        href={`${process.env.REACT_APP_BACKEND_URL}/api/packages/download/${token}/dossier.pdf`}
                        target="_blank"
                        rel="noreferrer"
                        className="gt-btn-primary px-5 py-2.5 text-sm inline-flex items-center ml-0 mt-2"
                    >
                        <i className="fa-solid fa-file-pdf mr-2" style={{ fontSize: 12 }}></i> Download Impact Dossier (PDF)
                    </a>
                    <div className="mb-8"></div>

                    <div className="space-y-10">
                        {pkg.images?.map((im, i) => (
                            <div key={im.id} className="grid grid-cols-1 lg:grid-cols-12 gap-6 pb-10" style={{ borderBottom: "1px solid var(--gt-border)" }}>
                                <div className="lg:col-span-7">
                                    <div className="gt-card overflow-hidden">
                                        <img src={im.image_url} alt={im.title} className="w-full object-cover" />
                                    </div>
                                </div>
                                <div className="lg:col-span-5">
                                    <div className="overline mb-2" style={{ fontSize: 10 }}>Image {String(i + 1).padStart(2, "0")} · {im.region}</div>
                                    <h3 className="font-display text-2xl mb-3">{im.title}</h3>
                                    <p className="text-sm mb-4" style={{ color: "var(--gt-text-2)" }}>{im.caption}</p>
                                    <div className="grid grid-cols-2 gap-2 text-xs">
                                        <div className="meta-chip"><i className="fa-solid fa-location-dot" style={{ fontSize: 10 }}></i> {im.gps || "—"}</div>
                                        <div className="meta-chip"><i className="fa-solid fa-camera" style={{ fontSize: 10 }}></i> {im.exif || "—"}</div>
                                        <div className="meta-chip"><span className="verif-dot"></span> C2PA {im.c2pa_hash}</div>
                                        <div className="meta-chip"><i className="fa-solid fa-calendar" style={{ fontSize: 10 }}></i> {im.date_shot || "—"}</div>
                                    </div>
                                    {im.consent && (
                                        <div className="mt-4 gt-surface p-4">
                                            <div className="overline mb-2">Consent record</div>
                                            <div className="text-xs" style={{ color: "var(--gt-text-2)" }}>
                                                {im.consent.subject_name} · {im.consent.location} · signed {im.consent.date_signed}
                                            </div>
                                            <div className="text-xs mt-1 font-mono">Permissions: {im.consent.usage_permissions}</div>
                                        </div>
                                    )}
                                    <a
                                        href={im.image_url}
                                        download
                                        target="_blank"
                                        rel="noreferrer"
                                        className="gt-btn-primary px-5 py-2.5 text-sm inline-flex items-center mt-4"
                                        data-testid={`pkg-download-${im.id}`}
                                    >
                                        <i className="fa-solid fa-download mr-2" style={{ fontSize: 11 }}></i> Download high-res
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}
